import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filter',
  standalone: true
})
export class FilterPipe implements PipeTransform {

  transform(items: any[], attribute: string, keyword, type, limit = null): any[] {
    if (!items || !keyword) {
      return items;
    }

    let filterItems = []

    if (type === 'equal') {
      filterItems = items.filter(item => (item[attribute] || '').toLowerCase() === keyword.toLowerCase()).slice(0, (limit === null ? items.length : limit));
      console.log(filterItems)
    } else if (type === 'contain') {
      filterItems = items.filter(item => (item[attribute] || '').toLowerCase().includes(keyword.toLowerCase())).slice(0, (limit === null ? items.length : limit));
    }

    return filterItems
  }

}
